module.exports = __webpack_public_path__ + "static/media/quote-right.47884f0c.svg";